import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { johnstonIAConfig } from "./data";

export default function JohnstonIAPage() {
  return <CityPageTemplate config={johnstonIAConfig} />;
}